// 推断当前应该连哪个 Relay：
// - 生产 Web (chatbox.jennieapp.com/app/...) → wss://chatbox.jennieapp.com/ws
// - Tauri 桌面 dev (file:// 或 localhost) → ws://localhost:8787/ws
// - 用户可通过 ?relay=... query 显式覆盖

export interface RelayConfig {
  readonly wsUrl: string;
}

const PROD_RELAY_WS = "wss://chatbox.jennieapp.com/ws";

export function inferRelayUrl(): RelayConfig {
  const explicit = new URLSearchParams(globalThis.location?.search ?? "").get(
    "relay",
  );
  if (explicit) return { wsUrl: ensureWs(explicit) };
  if (isPackagedTauri()) return { wsUrl: PROD_RELAY_WS };

  const loc = globalThis.location;
  if (!loc || loc.protocol === "file:") {
    return { wsUrl: "ws://localhost:8787/ws" };
  }

  if (loc.hostname === "localhost" || loc.hostname === "127.0.0.1") {
    return { wsUrl: "ws://localhost:8787/ws" };
  }

  const scheme = loc.protocol === "https:" ? "wss" : "ws";
  return { wsUrl: `${scheme}://${loc.host}/ws` };
}

function isPackagedTauri(): boolean {
  const w = globalThis.window as
    | (Window & { __TAURI_INTERNALS__?: unknown; __TAURI__?: unknown })
    | undefined;
  return Boolean((w?.__TAURI_INTERNALS__ || w?.__TAURI__) && import.meta.env.PROD);
}

function ensureWs(s: string): string {
  if (s.startsWith("ws://") || s.startsWith("wss://")) return s;
  return `ws://${s}`;
}
